import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/articles';
import { articleImages } from '@/mocks/images';

export default function ArticleGrid() {
  return (
    <section className="py-12 md:py-16" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="section-container">
        <h2 className="font-heading font-semibold text-xl md:text-2xl text-center mb-2 text-foreground-950">
          Latest VigorBuy Spreadsheet Guides
        </h2>
        <p className="text-sm text-center mb-8 text-foreground-600">
          In-depth articles covering reviews, comparisons, security, templates, and expert tips
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={article.slug === 'vigorbuy-spreadsheet-guide' ? '/vigorbuy-spreadsheet-guide' : `/article/${article.slug}`}
              className="group flex flex-col rounded-lg overflow-hidden transition-all duration-300 cursor-pointer"
              style={{ backgroundColor: 'oklch(var(--background-50))' }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div className="w-full aspect-[16/10] overflow-hidden">
                <img
                  src={articleImages[article.slug] || ''}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading font-semibold text-sm md:text-base mb-2 leading-snug text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500 mt-auto pt-3 border-t" style={{ borderColor: 'oklch(var(--background-200))' }}>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                  <span className="flex items-center gap-1 text-primary-500 font-medium">
                    Read Article
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}